import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "download",
  "use": "download-usage",
  "viewBox": "0 0 15.875 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.875 13\" id=\"download\"><path d=\"M43.677,47.539l-3.746-3.746.773-.773,2.426,2.426V37h1.093v8.446L46.65,43.02l.775.773Zm6.844-2.115v3.359a.13.13,0,0,1-.125.125H36.944a.119.119,0,0,1-.111-.125V45.423H35.74v3.359A1.213,1.213,0,0,0,36.944,50H50.4a1.22,1.22,0,0,0,1.218-1.219V45.423Z\" transform=\"translate(-35.74 -37)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol